import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { initGA, sendPageView } from "./gtag";
import { trackHubSpotPageView } from "./hubspot";
import { initMetaPixel, sendMetaPageView } from "./meta";

// GA4・Meta・HubSpot のページビューを、react-router のルート変更に追従させる。
//
// GA4 は send_page_view を切って初期化しているので、初回も含めて毎回ここから送る。
// Meta も公式スニペットの自動 PageView を使わず、初期化と送信を分けてある
// （貼っただけだとSPAでは初回の1ページしか計上されない）。
// HubSpot は埋め込みスクリプトが初回ロード分を自動送信するため、初回だけ送らない
// （送ると同じページが二重に計上される）。
export function usePageTracking() {
  const { pathname, search } = useLocation();
  const isFirstRun = useRef(true);

  useEffect(() => {
    initGA();
    initMetaPixel();
  }, []);

  useEffect(() => {
    const path = `${pathname}${search}`;

    sendPageView(path);
    sendMetaPageView();

    if (isFirstRun.current) {
      isFirstRun.current = false;
    } else {
      trackHubSpotPageView(path);
    }
  }, [pathname, search]);
}
